/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CultureResponseDto } from '../models/CultureResponseDto';
import type { DetailedUserDto } from '../models/DetailedUserDto';
import type { KeycloakUserWithRole } from '../models/KeycloakUserWithRole';
import type { PersonalUserSettingsDto } from '../models/PersonalUserSettingsDto';
import type { SetCultureDto } from '../models/SetCultureDto';
import type { SetRoleDto } from '../models/SetRoleDto';
import type { SystemSettingsDto } from '../models/SystemSettingsDto';
import type { TenantBlobFolder } from '../models/TenantBlobFolder';
import type { UploadSignatureResultDto } from '../models/UploadSignatureResultDto';
import type { UserDetailsDto } from '../models/UserDetailsDto';
import type { UserSettings } from '../models/UserSettings';
import type { UserSettingsDto } from '../models/UserSettingsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MolsonPriceCmdUsersApiService {

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAuthGettoken(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/gettoken',
        });
    }

    /**
     * Method allows you to get user
     * @param userId 
     * @returns DetailedUserDto OK
     * @throws ApiError
     */
    public static getUser(
userId: string,
): CancelablePromise<DetailedUserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Users',
            query: {
                'userId': userId,
            },
        });
    }

    /**
     * Method allows you to get user
     * @param userName 
     * @returns DetailedUserDto OK
     * @throws ApiError
     */
    public static getUserByName(
userName: string,
): CancelablePromise<DetailedUserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Users/GetByName',
            query: {
                'userName': userName,
            },
        });
    }

    /**
     * Method allows you to get all users or only active users
     * @param search 
     * @param onlyActive 
     * @returns KeycloakUserWithRole OK
     * @throws ApiError
     */
    public static getUsersList(
search?: string,
onlyActive?: boolean,
): CancelablePromise<Array<KeycloakUserWithRole>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Users/GetAll',
            query: {
                'search': search,
                'onlyActive': onlyActive,
            },
        });
    }

    /**
     * Method allows you to set role for user
     * @param requestBody 
     * @returns KeycloakUserWithRole OK
     * @throws ApiError
     */
    public static usersRoleSet(
requestBody: SetRoleDto,
): CancelablePromise<KeycloakUserWithRole> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/Users/Role',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Method allows you to set details for user
     * @param requestBody 
     * @returns UserDetailsDto OK
     * @throws ApiError
     */
    public static usersDetailsSet(
requestBody: UserDetailsDto,
): CancelablePromise<UserDetailsDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/Users/Details',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param userId 
     * @param width 
     * @param height 
     * @param formData 
     * @returns UploadSignatureResultDto Created
     * @throws ApiError
     */
    public static postUsersUploadSignature(
userId: string,
width: number,
height: number,
formData?: {
file: Blob;
},
): CancelablePromise<UploadSignatureResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/Users/UploadSignature',
            query: {
                'userId': userId,
                'width': width,
                'height': height,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Method allows you to get user settings
     * @param userName 
     * @returns UserSettingsDto OK
     * @throws ApiError
     */
    public static userSettings(
userName: string,
): CancelablePromise<UserSettingsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/User/Settings',
            query: {
                'userName': userName,
            },
        });
    }

    /**
     * Method allows you to get current user settings
     * @returns UserSettingsDto OK
     * @throws ApiError
     */
    public static userSettingsMy(): CancelablePromise<UserSettingsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/User/MySettings',
        });
    }

    /**
     * Method allows you to update current user personal settings
     * @param requestBody 
     * @returns UserSettings OK
     * @throws ApiError
     */
    public static userMyPersonalSettings(
requestBody: PersonalUserSettingsDto,
): CancelablePromise<UserSettings> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/User/MyPersonalSettings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Method allows you to update user personal settings
     * @param userName 
     * @param requestBody 
     * @returns UserSettings OK
     * @throws ApiError
     */
    public static userPersonalSettings(
userName: string,
requestBody: PersonalUserSettingsDto,
): CancelablePromise<UserSettings> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/User/PersonalSettings',
            query: {
                'userName': userName,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Method allows you to update system settings
     * @param requestBody 
     * @returns SystemSettingsDto OK
     * @throws ApiError
     */
    public static userSystemSettings(
requestBody: SystemSettingsDto,
): CancelablePromise<SystemSettingsDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/User/SystemSettings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Returns a short-lived SAS URL for uploading a file directly to Azure Blob Storage
     * @param folder 
     * @param fileName 
     * @returns string OK
     * @throws ApiError
     */
    public static uploadBlobFile(
folder: TenantBlobFolder,
fileName: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/Blob/Upload/{folder}',
            path: {
                'folder': folder,
            },
            query: {
                'fileName': fileName,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @returns CultureResponseDto OK
     * @throws ApiError
     */
    public static getCultureSettingsUsersApi(): CancelablePromise<CultureResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Culture',
        });
    }

    /**
     * @param requestBody 
     * @returns CultureResponseDto OK
     * @throws ApiError
     */
    public static setCultureUsersApi(
requestBody: SetCultureDto,
): CancelablePromise<CultureResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/Culture',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getSupportedCulturesUsersApi(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Culture/Supported',
        });
    }

}
